<template>
  <section>
    <div id="general" class="modal-card" style="width: auto">
      <header class="modal-card-head footerSourceModal-head">
        <p class="modal-card-title footerSourceModal-title">FAQ</p>
      </header>
      <section id="printBody" ref="PrintBody" class="modal-card-body footerSourceModal">
        <div v-html="$t('faq.faq_general')"></div>
      </section>
      <footer class="modal-card-foot footerSourceModal-foot">
        <b-button class="button" @click="print()">{{$t('faq.print_text')}}</b-button>
        <b-button class="button" @click="$parent.close()">{{$t('faq.close_text')}}</b-button>
      </footer>
    </div>
  </section>
</template>

<script>
import Vue from "vue";
import { Modal} from "buefy";
import Printd from "printd";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
Vue.use(Modal);
// Create VueI18n instance with options
export const i18n = new VueI18n({
  locale: 'en',
})

export default {
  i18n: {
    locale: 'en',
    messages: {
      en: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">General</h2>
            <h3 class="is-size-5">Why are certain industries named and grouped the way they are?</h3>
            <p>
              The information presented here is based on the most recent (2017) Canadian version of the 
              <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">North American Industry Classification System</a>. We use the 
              standard titles, definitions, and examples provided in the <a href="http://www.statcan.gc.ca/eng/subjects/standard/naics/2017v2/introduction" target="_blank">NAICS handbook</a>.
            </p>
            <h3 class="is-size-5">Why can't I find information for my industry and/or location?</h3>
            <p>
              The information may not exist in the combination you've chosen. For example, poppy flowers are not endemic to Canada so poppy farming is not likely to yield 
              results in any province selected.
            </p>
            <p>
              Sometimes an industry is represented by such a small number of businesses in a certain location that we can't share the data without violating the privacy of 
              those businesses. Other times, the information may be inaccurate or missing. In these cases, Statistics Canada has flagged the data as unreliable and we have 
              removed it from our collection.
            </p>
            <h3 class="is-size-5">Why am I being shown a different industry and/or location than the one I chose?</h3>
            <p>
              We always show the most detailed and specific information available. However, if information is not available for your choices, the program will show the most 
              similar industry or location for which information is available.
            </p>
            <p>
              In the case of location, this often means showing you national instead of provincial information.
            </p>
            <p>
              In the case of industry, this often means showing you information from a broader sector instead of the specific industry you chose. For example, we may not 
              have information on resorts in particular but we have information on the traveller accommodation sector (which includes resorts, hotels, motels, and motor 
              homes).
            </p>`,
          print_text: "Print",
          close_text: "Close"
        }
      },
      fr: {
        faq: {
          faq_general: `
            <h2 class="is-size-4">Générale</h2>
            <h3 class="is-size-5">Pourquoi certains secteurs d'activités sont nommés et groupés de cette façon?</h3>
            <p>
              L'information présenté ici est basé sur la version canadienne la plus récente (2017) du 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">Système de classification des industries de l'Amérique du Nord</a>. 
              Nous utilisons les titres, les définitions et les exemples standards fourni dans le 
              <a href="https://www.statcan.gc.ca/fra/sujets/norme/scian/2017v2/introduction" target="_blank">guide du SCIAN</a>.
            </p>
            <h3 class="is-size-5">Pourquoi je ne peux trouver l'information pour mon secteur d'activité et/ou l'emplacement?</h3>
            <p>
              L'information peut ne pas existé dans la combinaison que vous avez choisi. Par exemple, le coquelicot n'est pas une espèce endémique du Canada donc l'agriculture 
              du coquelicot ne produirait probablement pas des résultats dans l'une ou l'autre des provinces sélectionnées.
            </p>
            <p>
              Parfois un secteur d'activité est représenté par un faible nombre d'entreprises dans un certain emplacement que nous ne pouvons pas partager les données sans 
              faire abstraction à la protection de la vie privée de ses entrprises. En d'autre temps, l'information peut être inexacte ou manquant. Dans ces cas, Statistique 
              Canada a signalé les données comme un fonctionnement incertain et nous les avons retiré de notre collection.
            </p>
            <h3 class="is-size-5">Pourquoi je suis montré un secteur d'activité et/ou emplacement différent de ce que j'ai choisi?</h3>
            <p>
              Nous montrons toujours l'information la plus détaillé et spécifique disponible. Cependant, si l'information n'est pas disponible pour vos choix, le programme va 
              montrer le secteur d'activité ou l'emplacement le plus similaire dont l'information est disponible.
            </p>
            <p>
              Dans le cas de l'emplacement, ceci veut souvent dire qu'on vous montre l'information national au lieu de provincial.
            </p>
            <p>
              Dans le cas du secteur d'activité, ceci veut souvent dire qu'on vous montre l'information à partir d'un secteur plus générale au lieu d'un secteur d'activité 
              spécifique que vous avez choisi. Par exemple, nous n'avons peut-être pas l'information sur les centres de villégiature en particulier mais nous avons 
              l'information sur le secteur de l'hébergement des voyageurs (qui inclus centres de villégiature, hôtels, motels et maisons motorisées).
            </p>`,
          print_text: "Imprimer",
          close_text: "Fermer"
        }
      }
    }
  }, // end i18n
  props: [
    'lang',
  ],
  mounted: function() {
    this.$i18n.locale = this.toggleLang;
  },
  computed: {
    toggleLang: function() {
      return this.lang;
    }
  }, // end computed
  methods: {
    print: function() {
      const d = new Printd();
      d.print(this.$refs.PrintBody);
    }
  } // end methods
}
</script>
